module.exports = __webpack_public_path__ + "assets/img/face_attribute_scene2.a6ee868e.png";